<script lang="ts" setup>
import "./MCardSection.scss";
</script>
<template>
  <div class="m-card-section">
    <slot />
  </div>
</template>
